import { IGaModalViewedProps, IGaModalViewedEvent, gaLogEvent } from '../'

export const gaModalViewed = ({ name }: IGaModalViewedProps) => {
  const event: IGaModalViewedEvent = {
    event: 'modalViewed',
    DLV_modal_viewed_name: name,
  }
  gaLogEvent(event)
}
